import { ComponentType, FC, JSX, ReactNode } from "react";
import { Container, Flex, Text } from "@radix-ui/themes";
import Loader from "@/components/ui/Loader/Loader";
import { dataProps } from "@/models/data.model";
import { useData } from "@/hooks/useData";

type Props = {
  Countdown: ComponentType<dataProps>;
  Leaderboard: ComponentType<dataProps>;
  Endscreen: ComponentType<dataProps>;
  NoPlan?: ComponentType<dataProps>;
  Loading?: ComponentType; // brand-specific loading screen (default: spinner)
  noContainer?: boolean;
  extra?: ReactNode;
};

const FeaturePage: FC<Props> = ({
  Countdown,
  Leaderboard,
  Endscreen,
  NoPlan,
  Loading,
  noContainer,
  extra,
}): JSX.Element => {
  const { data, loading } = useData();

  if (loading) {
    if (Loading) return <Loading />;

    return (
      <Flex align="center" justify="center" width="100vw" height="100vh">
        <Loader />
      </Flex>
    );
  }

  const { hasOngoing, hasUpcoming, isFinished } = data;

  let content: JSX.Element;
  if (hasOngoing) content = <Leaderboard {...data} />;
  else if (hasUpcoming) content = <Countdown {...data} />;
  else if (isFinished) content = <Endscreen {...data} />;
  else if (NoPlan) content = <NoPlan {...data} />;
  else
    return (
      <Container>
        <Text>Failed to load leaderboard state</Text>
      </Container>
    );

  if (noContainer)
    return (
      <>
        {content}
        {extra}
      </>
    );

  return (
    <Container>
      {content}
      {extra}
    </Container>
  );
};

export default FeaturePage;
